import pathsGameCategories from '~/util/router/pathsGameCategories'

export default {
  registration: {
    path: '/registration',
  },
  home: {
    path: '/',
  },
  bonuses: {
    path: '/profile/bonuses',
    title: {
      ru: 'Бонусы',
      ua: 'Бонуси',
    },
  },
  gamePath: {
    path: '/game',
    title: {
      ru: 'Игровой зал',
      ua: 'Ігровий зал',
    },
    redirect: pathsGameCategories.slots.path,
  },
  faq: {
    path: '/faq',
    title: {
      ru: 'Часто задаваемые вопросы',
      ua: 'Поширені запитання',
    },
  },
}
